import { CitationCharts } from 'app/models/citation-charts.models';
import { IChartSelections } from '../models/chart.models';
import { Races } from '../models/person.models';

export const RACE_LABELS: Record<Races, string> = {
  [Races.BLACK]: 'B',
  [Races.ASIAN_PACIFIC_ISLANDER]: 'A',
  [Races.WHITE]: 'W',
  [Races.HISPANIC_LATINO]: 'H',
  [Races.ALASKA_NATIVE_AMERICAN_INDIAN]: 'AN',
};

export const DEFAULT_PERSON_SELECTIONS: IChartSelections = {
  [CitationCharts.DRIVER_AGE_GROUP]: [],
  [CitationCharts.CONTRABAND_OR_EVIDENCE_DISCOVERED]: [],
  [CitationCharts.GENDER]: [],
  [CitationCharts.RACE_ETHNICITY]: [],
  [CitationCharts.REASON_FOR_STOP]: [],
  [CitationCharts.REASON_FOR_SEARCH]: [],
  [CitationCharts.RESULT_OF_THE_STOP]: [],
};
